import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import * as B from 'react-bootstrap';
import RequestForm from '../../containers/RequestForm';
import Errorable from 'components/lib/Errorable';
import Banner from 'components/app/Banner';
import Panel from 'components/Panel';
import ChatCompanionNotAvailable from 'components/chat/companion/NotAvailable';
import ChatMain from 'containers/chat/';
import config from 'config';
import 'normalize.css';
import './app.scss'

@Errorable({ errorProp: 'requestError' })
class App extends React.Component {
  static propTypes = {
    companionAvailable: PropTypes.bool.isRequired,
    bindSizeToDOMElement: PropTypes.bool,
    manualMount: PropTypes.bool,
    doNotIncludeBootstrap: PropTypes.bool,
    canBeMinimized: PropTypes.bool,
    hideBanner: PropTypes.bool,
    mounted: PropTypes.bool.isRequired,
    ended: PropTypes.bool.isRequired,
    chatLoading: PropTypes.bool.isRequired,
    chatStarted: PropTypes.bool.isRequired,
    chatEnded: PropTypes.bool.isRequired,
    videoOngoing: PropTypes.bool.isRequired,
    userTimezoneOffset: PropTypes.number,
    connectionId: PropTypes.number,
    chatting: PropTypes.bool,
    chattingMaxHeight: PropTypes.number,
    chattingMaxWidth: PropTypes.number,
    fullscreenWidthBreakpoint: PropTypes.number,
    pendingMessages: PropTypes.number,
    hideSendButton: PropTypes.bool,
    unmountOnEnd: PropTypes.bool,
    onMount: PropTypes.func.isRequired,
    onRestore: PropTypes.func.isRequired,
    isOutOfSchedule: PropTypes.bool,
    isOutOfScheduleMessage: PropTypes.string,
  };
  static hideBannerHeightBreakpoint = 500;
  static hideBannerWidthBreakpoint = 600;
  static topBarHeight = 44;
  constructor(props) {
    super(props);

    if (!this.props.doNotIncludeBootstrap) {
      require('./bootstrap/styles/bootstrap.css');
    }

    this.state = {
      width: props.bindSizeToDOMElement ? 0 : window.innerWidth,
      height: props.bindSizeToDOMElement ? 0 : window.innerHeight,
      bannerHeight: 0,
      minimized: false,
    };
  }
  get heightExceded() {
    return this.props.hideBanner || (
      this.state.height < App.hideBannerHeightBreakpoint
      || this.state.width < App.hideBannerWidthBreakpoint
    );
  }
  get bindToWindowOnResize() {
    return !this.props.bindSizeToDOMElement || this.props.fullscreenWidthBreakpoint;
  }
  className(props) {
    props = props || this.props;
    if (this.state.minimized) {
      return 'minimized';
    } else if (props.chatting || props.chatEnded) {
      return 'chatting';
    } else {
      return undefined;
    }
  }
  minimize() {
    this.setState({ minimized: true });
    ReactDOM.findDOMNode(this).parentElement.classList.add('minimized');
  }
  maximize() {
    this.setState({ minimized: false });
    ReactDOM.findDOMNode(this).parentElement.classList.remove('minimized');
  }
  get height() {
    return this.state.height === 0 ? null : (
      this.state.height - (this.props.chatting ? 0 : App.topBarHeight)
    );
  }
  renderChatMain() {
    return (
      <ChatMain
        appWidth={this.state.width}
        appHeight={this.height}
        headerHeight={this.state.bannerHeight}
        assignEnvironmentFocusHandler={handler => window.onfocus = handler}
        assignEnvironmentBlurHandler={handler => window.onblur = handler}
        fullscreen={this.heightExceded}
        hideSendButton={this.props.hideSendButton}
        onMinimize={this.props.canBeMinimized && this.minimize.bind(this)}
        minimized={this.state.minimized}
      />
    );
  }
  renderChildren() {
    if (config.companionNeeded && !this.props.companionAvailable) {
      return <ChatCompanionNotAvailable />
    }

    if (this.props.isOutOfSchedule && this.props.isOutOfSchedule != undefined) {
      if (!this.props.chatStarted && !this.props.chatEnded) {
        return <RequestForm
          fullscreen={this.props.hideBanner}
          notVisible={this.state.minimized}
          appHeight={this.height}
          appWidth={this.state.width}
        />;
      } else {
        return (
          <Panel
            notVisible={this.state.minimized}
            appHeight={this.height}
            appWidth={this.state.width}
            fullscreen={this.heightExceded}
            hide={this.props.videoOngoing || this.props.hideBanner}
            wide={this.props.chatting || this.props.chatEnded}
          >
            { this.renderChatMain() }
          </Panel>
        );
      }
    } else {
      if (this.props.isOutOfSchedule == undefined) {
        return (<h5 className="text-center">Aguarde, consultando disponibilidad.</h5>);
      }
      return (
        <Panel
          notVisible={this.state.minimized}
          appHeight={this.height}
          appWidth={this.state.width}
          fullscreen={this.heightExceded}
          hide={this.props.videoOngoing || this.props.hideBanner}
          wide={this.props.chatting || this.props.chatEnded}
        >
          <h5 className="text-center">{this.props.isOutOfScheduleMessage}</h5>
        </Panel>
      );
    }
    
    
  }
  chattingResize() {
    if (this.props.chattingMaxHeight && this.props.chattingMaxWidth) {
      if (
        this.props.fullscreenWidthBreakpoint
        && window.innerWidth < this.props.fullscreenWidthBreakpoint
      ) {
        this.resize(window.innerWidth, window.innerHeight);
      } else {
        this.resize(this.props.chattingMaxWidth, this.props.chattingMaxHeight);
      }
    }
  }
  resize(width, height) {
    this.setState({ width, height });
  }
  end() {
    if (this.bindToWindowOnResize) {
      window.onresize = this.previousOnResize;
    }

    this.props.onEnd();

    if (this.props.unmountOnEnd) {
      ReactDOM.unmountComponentAtNode(ReactDOM.findDOMNode(this).parentElement);
    }
  }
  componentDidMount() {
    var that = this;

    if (this.props.connectionId && !this.props.chatEnded) {
      this.props.onRestore(this.props.connectionId);
    } else if (!this.props.manualMount) {
      this.props.onMount();
    }

    if (this.props.bindSizeToDOMElement) {
      let element = ReactDOM.findDOMNode(this).parentElement;
      this.resize(element.clientWidth, element.clientHeight);
    }
    if (this.bindToWindowOnResize) {
      this.previousOnResize = window.onresize;
      window.onresize = function() {
        if (that.props.bindSizeToDOMElement) {
          if (
            that.props.fullscreenWidthBreakpoint
            && window.innerWidth < that.props.fullscreenWidthBreakpoint
          ) {
            that.resize(window.innerWidth, window.innerHeight);
          } else {
            if (that.props.chatting || that.props.chatEnded) {
              that.chattingResize(true);
            } else {
              let element = ReactDOM.findDOMNode(that).parentElement;
              that.resize(element.clientWidth, element.clientHeight);
            }
          }
        } else {
          that.resize(window.innerWidth, window.innerHeight);
        }
        if (this.previousOnResize) {
          this.previousOnResize.apply(this, arguments);
        }
      };
      if (window.innerWidth < this.props.fullscreenWidthBreakpoint) {
        this.resize(window.innerWidth, window.innerHeight);
      }
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.bindSizeToDOMElement) {
      if (
        (nextProps.chatting && !this.props.chatting)
        || (nextProps.ended && !this.props.chatEnded)
      ) {
        ReactDOM.findDOMNode(this).parentElement.classList.add('chatting');;
        this.chattingResize();
      } else if (
        (!nextProps.chatting && this.props.chatting)
        || (!nextProps.ended && this.props.chatEnded)
      ) {
        ReactDOM.findDOMNode(this).parentElement.classList.remove('chatting');;
        this.chattingResize();
      }
    }
  }
  renderMinimized() {
    return (
      <div className="chat-minimized">
        <B.Glyphicon glyph="comment" />
        {
          this.props.pendingMessages ? (
            <div className="chat-pending-count">
              <span className="chat-pending-count-number">{this.props.pendingMessages}</span>
            </div>
          ) : undefined
        }
      </div>
    );
  }
  render() {
    if (this.props.ended) {
      return null;
    }

    return (
      <div id="app-wrapper" ref={c => this.wraper = c} className={this.className()}
        onClick={this.state.minimized ? this.maximize.bind(this) : undefined}
      >
        { this.state.minimized ? this.renderMinimized() : undefined }
        {
          this.state.minimized || this.props.hideBanner || (this.props.chatStarted && (this.props.videoOngoing || this.heightExceded)) ? undefined : (
            <Banner appWidth={this.state.width} appHeight={this.state.height}
              ref={c => this.banner = c} onBannerHeightChange={bannerHeight => this.setState({ bannerHeight })} />
          )
        }
        {
          !this.state.minimized && this.props.canBeMinimized && !this.props.chatting ? (
            <div className="app-topbar">
              <B.Button className="app-topbar-left app-top-close-chat" bsStyle="link" onClick={this.end.bind(this)}>
                <B.Glyphicon glyph="remove" />
              </B.Button>
              <B.Button className="app-topbar-right app-top-minimize-chat" bsStyle="link" onClick={this.minimize.bind(this)}>
                <B.Glyphicon glyph="minus" />
              </B.Button>
            </div>
          ) : undefined
        }
        { !this.state.minimized && (this.props.chatStarted || this.props.chatEnded) ? this.error() : undefined }
        {this.renderChildren()}
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./components/app/index.js